export const paths = {
  root: "/",
  login: "/login",
  registration: "/registration",
  verifyEmail: "/verify-email",
  forgetPassword: "/forget-password",
  resetPassword: "/reset-password",
  formInstruction: "/form",
  guestApplication: "/guest-application",
  dataSecurity: "/data-security",
  internshipManagementSystem: "/internship-management-system",
  aboutUs: "/about-us",
  contactUs: "/contact-us",
  privacyPolicy: "/privacy-policy",
  helpCenter: "/help-center",
  jobs: "/jobs",
  careers: "/careers",
  careerJobsList: "jobs",
  careerDetails: "career-details",
  common: {
    onboarding: "/auth/onboarding",
    searchResult: "/auth/search-result",
    accountSetting: "/auth/account-setting",
    inviteMember: "/auth/invite-member",
    careerHub: "/auth/career-hub",
    viewProfile: "/auth/view-profile",
    analytics: "/auth/analytics",
    plutoConnect: "/auth/pluto-connect",
  },
  admin: {
    dashboard: "/auth/admin-dashboard",
    // settings: "/auth/admin-settings",
    applicationStatus: {
      root: "/auth/admin-application-status",
      overview: "/overview",
      chat: "/chat",
      email: "/email",
      logs: "/logs",
      timeline: "/timeline",
      document: "/document",
      details: "/auth/admin-application-status/details",
    },
    projects: "/auth/admin-projects",
    email: "/auth/admin-email",
    emailBuilder: "/auth/admin-email-builder",
    recommendation: "/auth/recommendation",
    settings: {
      root: "/auth/admin-settings",
      stages: "stages",
      actions: "actions",
      field: "fields",
      attributes: "attributes",
      attributesDetails: "/auth/admin-settings/attributes/details",
      roles: "roles",
      groups: "groups",
    },
    masterData: {
      root: "/auth/admin-master-data",
      details: "/auth/admin-master-data/details",
    },
    events: {
      root: "/auth/admin-events",
      create: "/auth/admin-events/create",
      details: "/auth/admin-events/details",
    },
    offerLetter: {
      root: "/auth/admin-offer-letter",
      create: "/auth/admin-offer-letter/create",
      edit: "/auth/admin-offer-letter/edit",
    },
    rules:{
      root: "/auth/admin-rules",
      create: "/auth/admin-rules/create",
    }
  },
  applicant: {
    dashboard: "/auth/applicant-dashboard",
    email: "/auth/applicant-email",
  },
  formBuilder: {
    dashboard: "/auth/form-builder/dashboard",
    workflow: "/auth/workflow/dashboard",
    customizeForm: {
      root: "/auth/form-builder/customize-form",
      formDesign: "form-design",
      formSetting: {
        root: "form-setting",
        generalSettings: "general-settings",
        startendScreen: "startend-screen",
        emailSettings: "email-settings",
        userCollaboration: "user-collaboration",
        appIntegration: "app-integration",
      },
    },
    applicationForm: "/auth/form-builder/application-form",
  },
};
